export enum OrderEntryFormMode {
    Add,
    Edit
}